module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mobile-menu"
    }
  }, [_c('div', {
    staticClass: "mobile-menuitem",
    on: {
      "click": function($event) {
        _vm.changeRoute('Index')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('layout.menuIndex')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menuitem",
    on: {
      "click": function($event) {
        _vm.changeRoute('Technology')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('layout.menuTech')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menuitem",
    on: {
      "click": function($event) {
        _vm.changeRoute('Contact')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('layout.menuContact')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menuitem",
    on: {
      "click": function($event) {
        _vm.changeRoute('Login')
      }
    }
  }, [_c('a', {
    staticClass: "btn btn-light btn-rounded",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('layout.menuLogin')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "escape-mobilemenu",
    on: {
      "click": function($event) {
        _vm.$store.state.mobileMenu = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "locale-wrapper"
  }, _vm._l((_vm.locales), function(locale, index) {
    return _c('div', {
      key: locale,
      staticClass: "locale",
      class: {
        'active': _vm.$i18n.locale === index
      },
      on: {
        "click": function($event) {
          _vm.$i18n.locale = index
        }
      }
    }, [(index === 'da') ? _c('img', {
      attrs: {
        "src": "/static/images/flags/dk.png"
      }
    }) : _vm._e(), _vm._v(" "), (index === 'en') ? _c('img', {
      attrs: {
        "src": "/static/images/flags/gb.png"
      }
    }) : _vm._e()])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc8f76c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/layout/mobile-menu.vue
// module id = 318
// module chunks = 1